export const environment = {
  production: true,
  applicationURL: "https://pump-qr-code-generator-prd.hrt.cloud/",
  API_ENDPOINT_PLATFORM: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/',
  API_ENDPOINT_Facility: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/v0.1/',
  API_ENDPOINT_FacilityVersion: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/v0.4/',
  PLATFORM_AUTH: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/v0.4/',
  PLATFORM_AUTH_Register: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/v0.5/',
  ClientId: "8b8037cb-ba85-48bd-86de-49685b2756d1",
  appId: '25685446-38a7-430e-88d9-a0a7ff9404c8',
  appCustomerRoleId: 'a9cfe41949cd44a090b983a73a89ff86',
  appHartmannRoleId: '13a20fe43aa442ccb65609dc85933359',
  loginAccesstok: "8080808080808080",
  countryVal: 'DE',
  regionCode: '',
  produnctionFlag: false,
  ClientSecret: "OGI4MDM3Y2ItYmE4NS00OGJkLTg2ZGUtNDk2ODViMjc1NmQx",
  PLATFORM_Redirect: "https://prd-www-hartmann-info.hrt.cloud",
  Platform_URI: 'https://pump-qr-code-generator-prd.hrt.cloud/',
  ClientIDSignIn: '1132adff-61a2-4675-a8db-541b83d13f94',
  PLATFORM_AUTH_PH: 'https://prd-auth-api-hartmann-info.hrt.cloud/',
  Platform_URI_Redirect: 'https://prd-www-hartmann-info.hrt.cloud',
  PLATFORM_AUTH_PH_SOC: 'https://prd-auth-api-hartmann-info.hrt.cloud/api/',
  API_PLATFORM_SEARCH: 'https://prd-utility-api-hartmann-info.hrt.cloud/api/v0.1/',
  appasset: 'https://storagedhhpuat.blob.core.windows.net/platformassets/appasset/',
  API_TESTING_SERVICES: 'https://prd-utility-api-hartmann-info.hrt.cloud/api/v0.1/',
  firebase: {
    apiKey: "AIzaSyA_TX-dSGVWpqn-MUpi7VeQWt177qNPyZM",
    authDomain: "pump-message.firebaseapp.com",
    projectId:"pump-message",
    storageBucket:"pump-message.firebasestorage.app",
    messagingSenderId:"321919380594",
    appId: "1:321919380594:web:287d3daa6179c96d63a6eb"
  },
  functionAppBaseUri: 'https://pump-qr-code-be-prd.hrt.cloud/'
};